<template>
  <v-app>
    <core-toolbar />
    <core-view />
  </v-app>
</template>
<script>
import CoreToolbar from '@/components/core/toolbar.vue'
import CoreView from '@/components/core/view.vue'
export default {
  components: {
    CoreToolbar,
    CoreView,
  },
}
</script>
